<template>
  <a-modal
    :title="title"
    :visible="viz"
    :footer="null"
    @cancel="viz = false"
  >
    <a-upload-dragger
      name="file"
      accept=".xlsx,.xls"
      :headers="{token:$getToken()}"
      :multiple="false"
      :before-upload="beforeUpload"
      :action="uploadURL"
      @change="handleChange"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">
        点击或者拖拽文件到这里上传
      </p>
      <p class="ant-upload-hint">
        只支持上传.xls，.xlsx文件，且不能超过100条
      </p>
    </a-upload-dragger>
    <div class="mt-10"><a target="_blank" href="/ordertpl.xlsx" type="link">下载Excel收件人模板文件</a> </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    max: {
      type: Number,
      default: 1
    },
    title: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploadURL: process.env.VUE_APP_BASE_API + '/address/getExcelAddress.json',
      viz: this.show,
      fileList: []
    }
  },
  watch: {
    viz(n) {
      this.$emit('update:show', n)
    },
    show(n) {
      this.viz = n
    }
  },
  methods: {
    beforeUpload(f) {
      const file = f.name
      const ext = file.slice(file.lastIndexOf('.') + 1).toLowerCase()
      if (ext !== 'xls' && ext !== 'xlsx') {
        this.$message.error('请上传Excle文件')
        return false
      }
      if (this.fileList.length > this.max || this.fileList.length === this.max) {
        this.$message.error('最多只能上传' + this.max + '个文件')
        return false
      }
    },
    handleChange(info) {
      this.fileList = info.fileList
      if (!info.file.status) {
        info.fileList.pop()
      }
      const status = info.file.status

      if (status === 'done') {
        if (info.file.response && info.file.response.state !== 'success') {
          this.$message.error(`${info.file.name} 文件上传失败.`)
          return
        }
        this.$message.success(`${info.file.name} 文件上传成功.`)
        this.viz = false

        this.$emit('ok', [...info.file.response.data])
        info.fileList = []
        this.fileList = info.fileList
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 文件上传失败.`)
      } else if (status === 'removed') {
        this.$message.success(`${info.file.name} 文件删除成功.`)
      }
    },
    success() {
      if (this.fileList.length < 1) {
        this.$message.error('请上传文件')
        return
      }
      this.$emit('ok', this.fileList.map(el => el.response.data.filePath))
    }
  }
}
</script>
